<template>
    <div class="container">
        <div class="recommendBox">
            <div class="recommend" v-for="(item,index) in arrCustomerList" :key="index" @click="clickItem(item)">
                <!-- <div class="status"  v-if="item.status != 3">
                    <span v-if="item.status == 1">待联系</span>
                    <span v-if="item.status == 2">已联系</span>
                </div> -->
                <!-- <div class="status2"  v-if="item.status == 3"> -->
                <div class="status">
                    <span>{{item.new_status}}</span>
                </div>
                <div class="name">客户姓名:{{item.name}}</div>
                <div class="info">
                    <div class="phone">
                        电话:{{item.phone}}
                    </div>
                    <div class="recommendTime">
                        推荐时间:{{hanlderTime(item.created_at)}}
                    </div>
                </div>
                <div class="line"></div>
                <div class="address">
                    地址:{{item.province_name+item.city_name+item.dist_name+item.address}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import oRecommend from '@/js/recommend.js'

export default {
    created() {
        $init(() => {
            this.getReferList()
        })
    },
    data() {
        return {
            arrCustomerList: [
                //{name:"蓝精灵",status:1,phone:"1770302548",recommend:"2021-09-21",address:"南京市西夏区小新大道336号"},
                //{name:"蓝精灵",status:2,phone:"1770302548",recommend:"2021-09-21",address:"南京市西夏区小新大道336号"},
                //{name:"蓝精灵",status:3,phone:"1770302548",recommend:"2021-09-21",address:"南京市西夏区小新大道336号"},
            ]
        }
    },
    methods: {
        getReferList() {
            this.$store.commit("loadSwitch", true);
            oRecommend.getReferList().then(res => {
                this.arrCustomerList = res.data.data.result;
                this.$store.commit("loadSwitch", false);
            })
        },
        hanlderTime(val) {
            return val.slice(0, 10)
        },
        clickItem(val) {
            this.$router.push({
                path: '/user/house/recommenddetail',
                query: {
                    id: val.id,
                }
            })
        }
    }
}
</script>
<style lang='scss' scoped>
.container {
    width: 100%;
    height: 100%;
    background-color: #f0f4f1;
    .recommendBox {
        padding: 0 24px;
        .recommend {
            margin-top: 24px;
            padding: 28px 28px 18px 28px;
            background-color: #ffffff;
            border-radius: 12px;
            position: relative;
            .status {
                position: absolute;
                top: 0;
                right: 0;
                padding: 6px 24px;
                background: #318544;
                border-radius: 0px 12px 0px 12px;
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
            }
            .status2 {
                position: absolute;
                top: 0;
                right: 0;
                padding: 6px 24px;
                background: rgba($color: #318544, $alpha: 0.3);
                border-radius: 0px 12px 0px 12px;
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
            }
            .name {
                font-size: 32px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #318544;
                line-height: 44px;
            }
            .info {
                margin: 20px 0;
                display: flex;
                justify-content: space-between;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #444444;
                line-height: 40px;
            }
            .line {
                width: 100%;
                height: 4px;
                background-color: #f5f5f5;
            }
            .address {
                margin-top: 14px;
                font-size: 24px;
                font-weight: 400;
                color: #a2a2a2;
                line-height: 34px;
            }
        }
    }
}
</style>